import { useSnapshot } from 'hooks/use-safe-snapshot';
import { sidebarNavState } from 'state/sidebar-nav';

const useSidebarNav = () => {
    const state = useSnapshot(sidebarNavState);

    return state;
};

export { useSidebarNav };
